var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding-top":"100px","text-align":"center","font-size":"16px"}},[_vm._v("正在获取数据,请稍候...")])}
var staticRenderFns = []

export { render, staticRenderFns }